




import Vue from 'vue';
import { MetaInfo } from 'vue-meta';

export default Vue.extend( {
	head(): MetaInfo {
		return {
			title: `${this.$t( 'views.not-found.properties' )}`
		};
	}
} );
